import "../CSS/Ploeg.css";

function U12() {
  return (
    <div className="ploegoverzicht">
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_126231/overzicht"
      />
    </div>
  );
}

export default U12;
